export const stateName = 'notifications';